export const position = {
  x: -5142.889893896558,
  y: 7646.334948489274,
  z: 7294.129584585374
};

export const MALLIGYOUNG_1 = 58400;
export const KORSAT_7 = 58463;
export const DOORY_SAT = 58500;
export const KORSAT_1 = 59452;
export const KORSAT_2 = 62377;

export const NEXTSAT_2 = 56743;
export const OBJECT_B = 56744;
export const OBJECT_C = 56745;
export const OBJECT_D = 56746;
export const OBJECT_E = 56747;
export const OBJECT_F = 56748;
export const OBJECT_G = 56749;
export const KSLV_II_RB = 56750;

const SCOT_1 = 62617;
const SATORO_T2 = 60477;
const GALASSIA_2 = 57486;
const ARCADE = 57485;
const SCOOBII = 57484;
const VELOX_AM = 57482;
const TELEOS_2 = 56310;
const LUMELITE_4 = 56309;
const SCOOB_1 = 52938;
const NEUSAR = 52937;
const DS_EO = 52935;
const TELEOS_1 = 41169;
const KENT_RIDGE_1 = 41167;
const VELOX_C1 = 41166;
const VELOX_1 = 40057;
const POPSAT_HIP_1 = 40028;
const VELOX_P_2 = 39438;
const XSAT = 37389;

export const malligyongIds = [
  MALLIGYOUNG_1,
  KORSAT_7,
  DOORY_SAT,
  KORSAT_1,
  KORSAT_2
];

export const nuriIds = [
  NEXTSAT_2,
  OBJECT_B,
  OBJECT_C,
  OBJECT_D,
  OBJECT_E,
  OBJECT_F,
  OBJECT_G,
  KSLV_II_RB
];

export const NTU_SAT_IDS = [
  SCOT_1,
  SATORO_T2,
  GALASSIA_2,
  ARCADE,
  SCOOBII,
  VELOX_AM,
  TELEOS_2,
  LUMELITE_4,
  SCOOB_1,
  NEUSAR,
  DS_EO,
  TELEOS_1,
  KENT_RIDGE_1,
  VELOX_C1,
  VELOX_1,
  POPSAT_HIP_1,
  VELOX_P_2,
  XSAT
];

export const KDIC_IDS = [
  62377, 59452, 58463, 58500, 58400, 47932, 40536, 39227, 38338, 29268
];

export const MALAY_IDS = [
  57197, 52904, 40147, 35578, 35362, 29648, 26548, 24653, 23765
];
